<template>
  <div class="full-height">
    <vs-popup :title="$t('PropertiesTitle')" :active.sync="InPropertiesMenu" v-if="InPropertiesMenu">
      <TabContainer :onboarding="selectedOnboarding"></TabContainer>
    </vs-popup>

    <vs-popup title="Edit onboarding" :active.sync="InSpaceEditMode" v-if="InSpaceEditMode">
      <EditSpace :space="selectedSpace"></EditSpace>
    </vs-popup>

    <vs-popup :title="$t('Link')" :active.sync="AfterShare" v-if="AfterShare">
      {{$t('Link')}}:
      <p v-if="AfterShare">{{onboardingLink}}</p>
    </vs-popup>

    <vs-popup :title="$t('CreateSpaceTitle')" :active.sync="InSpaceCreationMode" v-if="InSpaceCreationMode">
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('TitleLabel')" v-model="spaceTitle" />
        </div>
        <div class="vx-col w-full mb-base">
          <vs-textarea class="vx-col w-1/1 lg:w-1/1" style="width:100%;" :label-placeholder="$t('DescriptionLabel')" v-model="spaceDescription" />
        </div>
        <div class="vx-col w-full mb-base">
          <vs-checkbox success v-model="hideSpaceFromSidebar">
            {{$t('HideSpaceFromSidebar')}}
          </vs-checkbox>
        </div>
        <!--<div class="vx-col w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Subscription ID" v-model="spaceSubscriptionId" />
        </div>
        <div class="vx-col w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Payment Link" v-model="spacePaymentLink" />
        </div>
        <div class="vx-col w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Title" v-model="certificateTitle" />
        </div>
        <div class="vx-col w-full mb-base">
          <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Icon Path" v-model="certificateIcon" />
          <input type="file" @change="uploadCertificateIcon($event)" accept="image/*" style="margin-top: 8px;" />
        </div>
        <div class="vx-col w-full mb-base">
          <vs-textarea class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Certificate Description" v-model="certificateDescription" />
        </div>-->
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full mb-base">
          <vs-button typeof="flat" @click="CreateSpace()">{{$t('CreateSpace')}}</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- Header Section -->
    <div class="vx-row mb-6">
      <div class="vx-col w-full md:w-1/1 lg:w-1/1 xl:w-1/1">
        <div class="header-section">
          <h1 class="page-title">{{$t('ManageSpaces')}}</h1>
          <p class="page-description">{{$t('ManageSpacesDescription')}}</p>
          
          <!-- Create Space Button - Only show when there are spaces -->
          <div v-if="$acl.check('editor') && spaces.length > 0" class="create-space-section">
            <vs-button 
               @click="OpenSpaceCreationMenu" 
               color="primary" 
               size="default"
               class="create-space-btn"
               icon-pack="feather"
               icon="icon-plus"
             >
              {{$t('CreateNewSpace')}}
             </vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div v-if="spaces.length === 0" class="vx-row">
      <div class="vx-col w-full">
        <div class="empty-state">
          <div class="empty-state-icon">
            <FeatherIcon icon="FolderIcon" size="48" />
          </div>
          <h2 class="empty-state-title">{{$t('NoSpacesYet')}}</h2>
          <p class="empty-state-description">{{$t('NoSpacesYetDescription')}}</p>
          <div v-if="$acl.check('editor')" class="empty-state-action">
             <vs-button 
               @click="OpenSpaceCreationMenu" 
               color="primary" 
               size="default"
               class="empty-state-btn"
               icon-pack="feather"
               icon="icon-plus"
             >
              {{$t('CreateYourFirstSpace')}}
             </vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Spaces Grid -->
    <div v-else class="vx-row">
      <div v-for="(space) in spaces" :key="space.Id"
           class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-base">
        <vx-card style="" :title="space.title" title-color="#000" content-color="#000" class="small-card">
          <p>
            {{ space.description ? space.description : $t('OnboardingNoDescriptionYet') }}
          </p>
          <div slot="footer">
            <vs-row vs-justify="flex-end" style="flex-flow:nowrap">
              <a :href="'/pages/space/' + space.id" class="p-3" target="_blank">{{$t('Open')}}</a>
              <vs-button v-if="$acl.check('editor')" @click="OpenSpaceEditMenu(space)" class="mr-5" color="primary" type="flat">{{$t('Edit')}}</vs-button>
              <vs-button v-if="$acl.check('editor')" @click="DeleteSpace(space.id)" color="danger" type="flat">{{$t('Delete')}}</vs-button>
            </vs-row>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import { AclRule } from 'vue-acl'
  import DeleteOnboardingLink from '@/views/components/atoms/onboardings/DeleteOnboardingLink'
  import TabContainer from '@/views/ui-elements/tabs/TabContainer.vue'
  import EditSpace from '@/views/components/spaces/EditSpace.vue'
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import FeatherIcon from "@/components/FeatherIcon.vue";
  //import tiptap from "@/views/components/extra-components/editors/tiptap.vue";

  export default {
    data() {
      return {
        itemsPerPage: 20,
        spaces: [],
        spaceTitle: "",
        spaceDescription: "",
        spaceSubscriptionId: "",
        spacePaymentLink: "",
        InSpaceEditMode:false,
        InSpaceCreationMode: false,
        selectedOnboarding: null,
        InPropertiesMenu: false,
        AfterShare: false,
        selectedSpace: null,
        hideSpaceFromSidebar:false,
        certificateTitle: '',
        certificateIcon: '',
        certificateDescription: '',
      }
    },
    mounted() {
      this.FetchSpaces()
    },

    methods: {
      OpenSpaceCreationMenu() {
        this.InSpaceCreationMode = true;
      },

      OpenSpaceEditMenu(space) {
        this.InSpaceEditMode = true;
        this.selectedSpace = space;
      },

      FetchSpaces() {
        var instance = this;
        var req = JSON.stringify({
          query: `query Spaces {
              spaces(order: { title: ASC } where: { rootId: {eq:null} }) {
              title
              description
              id
              icon
              urlName
              hideFromSidebar
              subscriptionId
              paymentLink
              certificateTitle
              certificateIcon
              certificateDescription
          }
          }`});

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.spaces = response.data.data.spaces;
          }
        });
      },

      DeleteSpace(spaceId) {
        if (confirm("Are you sure?The SOPs in this space will still be available in the 'Discover' section.")) {
          
        } else {
          return;
        }
        var instance = this
        const query = `
    mutation DeleteSpace($spaceId:Int!) {
    deleteSpace(spaceId: $spaceId)
 }
`;
        const variables = {
          spaceId: spaceId
        }

        const req = {
          query,
          variables
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data) {

            instance.$vs.notify({
              title: instance.$t('SuccessExclamation'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
            location.reload()
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :( ');
            console.error("ERROR SAVING ONBOARDING: ", response.data);
          }
        });
      },

      CreateSpace() {
        var instance = this
        const spaceVariables = {
          id: 0,
          title: instance.spaceTitle,
          description: instance.spaceDescription,
          icon: "",
          urlName: "",
          hideFromSidebar: instance.hideSpaceFromSidebar,
          subscriptionId: instance.spaceSubscriptionId,
          paymentLink: instance.spacePaymentLink,
          certificateTitle: instance.certificateTitle,
          certificateIcon: instance.certificateIcon,
          certificateDescription: instance.certificateDescription,
        }
        const query = `
          mutation AddSpace($space: SpaceInput!) {
            addSpace(entity: $space) {
              id,
              title,
              description,
              icon,
              urlName,
              hideFromSidebar,
              subscriptionId,
              paymentLink
              }
       }
      `;
        const variables = {
          space: spaceVariables
        }

        const req = {
          query,
          variables
        };
        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data.data) {
            instance.spaceTitle = ""
            instance.spaceDescription = ""
            instance.spaceSubscriptionId = ""
            instance.spacePaymentLink = ""
            instance.certificateTitle = ""
            instance.certificateIcon = ""
            instance.certificateDescription = ""
            instance.InSpaceCreationMode = false
            instance.FetchSpaces()
            instance.$vs.notify({
              title: instance.$t('SuccessExclamation'),
              color: "success",
              iconPack: "feather",
              position: "top-center",
              icon: "icon-check-circle",
            });
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :( ');
            console.error("ERROR SAVING ONBOARDING: ", response.data);
          }
        });

      },

      async uploadCertificateIcon(event) {
        const file = event.target.files[0];
        if (!file) return;
        const formData = new FormData();
        formData.append('file', file);
        try {
          const response = await TCVelikClient.PostRelative('/api/upload/certificate-icon', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });
          if (response && response.data && response.data.relativeUrl) {
            this.certificateIcon = response.data.relativeUrl;
            this.$vs.notify({
              title: 'Success!',
              text: 'Icon uploaded.',
              color: 'success',
              iconPack: 'feather',
              position: 'top-center',
              icon: 'icon-check-circle',
            });
          } else {
            throw new Error('No relativeUrl returned');
          }
        } catch (e) {
          this.$vs.notify({
            title: 'Error!',
            text: 'Failed to upload icon.',
            color: 'danger',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-alert-circle',
          });
        }
      },

      SaveChanges(onboarding) {
        const query = `
          mutation UpdateOnboarding($onboarding: OnboardingInput!) {
            updateMainFields(
              entity: $onboarding
            ) {
              id,
              name
              description
              rawContent
            }
          }
        `;

        const variables = {
          onboarding: onboarding
        };

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            alert("You're good to go.");
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :(');
          }
        });
      },
    },
    components: {
      DeleteOnboardingLink,
      TabContainer,
      EditSpace,
      FeatherIcon,
    }
  }
</script>
<style>
  body {
    background: #fff;
    padding: 20px;
  }

  .layout--full-page {
    height: 500px;
  }

  .onboarding-recorder.email .vs-collapse-item {
    background: white !important;
  }

  .onboarding-recorder.email .vs-collapse-item--header {
    background: white !important;
  }

  .onboarding-recorder.email .step-tools {
    display: none !important;
  }

  .onboarding-recorder.email .icon-header {
    display: none !important;
  }

  .onboarding-recorder.email .screenshot {
    max-width: 300px !important;
  }

  .pointer {
    cursor: pointer;
  }

  .commands {
    position: fixed;
    bottom: 0px;
  }

  .full-height {
    height: 100%;
  }

  img.screenshot {
    max-width: 80%;
    opacity: 0.8;
  }

  .onboarding-recorder .vs-collapse-item--header {
    background: #efefef;
    margin-bottom: 10px;
  }

  .vx-card__title {
    max-height: 1.5em;
    overflow: hidden;
    height: 1.5em;
  }

  .small-card {
    position: relative;
    cursor: pointer;
    background-size: cover;
    background-repeat: no-repeat;
    color: black;
  }

    .small-card .vx-card__title h4 {
      font-weight: 900;
    }

    .small-card .vx-card__body {
      max-height: 120px;
      height: 120px;
      margin-bottom: 5px;
      overflow: hidden;
    }

    .small-card .vx-card {
      border: 1px solid var(--primary);
    }

      .small-card .vx-card:hover {
        transform: scale(1.1);
        z-index: 999999;
      }

    .small-card .vx-card__body img {
      margin-top: 10px;
      opacity: 0.4;
      filter: grayscale(1);
    }

    .small-card .vx-card:hover img {
      filter: grayscale(0);
      opacity: 1;
    }

    .small-card .vx-card:hover h4 {
      color: var(--primary) !important;
    }

  /* Header Section Styles */
  .header-section {
    padding: 20px 0;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 30px;
  }

  .page-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 10px;
  }

  .page-description {
    font-size: 1.1rem;
    color: #7f8c8d;
    margin-bottom: 25px;
    line-height: 1.6;
  }

  .create-space-section {
    margin-top: 20px;
  }

  .create-space-btn {
    font-weight: 600;
    padding: 8px 16px;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  .create-space-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  /* Empty State Styles */
  .empty-state {
    text-align: center;
    padding: 40px 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    border: 2px dashed #dee2e6;
    margin: 40px 0;
  }

  .empty-state-icon {
    margin-bottom: 15px;
    color: #6c757d;
  }

  .empty-state-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 10px;
  }

  .empty-state-description {
    font-size: 1rem;
    color: #6c757d;
    margin-bottom: 25px;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.5;
  }

  .empty-state-action {
    margin-top: 15px;
  }

  .empty-state-btn {
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 8px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    font-size: 1rem;
  }

  .empty-state-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .page-title {
      font-size: 2rem;
    }
    
    .empty-state {
      padding: 40px 15px;
    }
    
    .empty-state-title {
      font-size: 1.5rem;
    }
  }
</style>
